import { CheckoutProvider } from "@stripe/react-stripe-js";
import { PaymentForm } from "./components/payment-form";
import { useDataEntryStep5 } from "./data-entry-step-5.hook";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const DataEntryStep5 = () => {
  const { stripePromise, clientSecret, appearance } = useDataEntryStep5();

  const SkeletonLoader = (
    <>
      <div className="col-md-9">
        <div className="d-flex flex-row gap-2" style={{ marginBottom: "10px" }}>
          <div className="flex-grow-1">
            <Skeleton height={50} />
          </div>
          <div className="flex-grow-1">
            <Skeleton height={50} />
          </div>
        </div>
        <Skeleton count={2} height={50} style={{ marginBottom: "10px" }} />
      </div>

      <div className="justify-content-end ps-md-3 mt-3 mt-md-0 col-md-3">
        <Skeleton height={120} />
      </div>
    </>
  );

  return (
    <>
      <div
        className="d-flex flex-column flex-md-row ps-3 pe-3"
        style={{ minHeight: "300px" }}
      >
        {!clientSecret ? (
          SkeletonLoader
        ) : (
          <CheckoutProvider
            stripe={stripePromise}
            options={{
              fetchClientSecret: () => Promise.resolve(clientSecret),
              elementsOptions: {
                appearance,
              },
            }}
          >
            <PaymentForm />
          </CheckoutProvider>
        )}
      </div>
    </>
  );
};
